import script from "./my-branches.vue?vue&type=script&setup=true&lang=js"
export * from "./my-branches.vue?vue&type=script&setup=true&lang=js"

import "./my-branches.vue?vue&type=style&index=0&id=1c54b0ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c54b0ef"]])

export default __exports__